import React, {useEffect, useState} from 'react';
import {Grid} from "@mui/material";
import SideMenu from "./SideMenu";
import Footer from "./Footer";
import Header from "./Header";
import {ResourceMenuDto} from "../modules/account/dto/ResourceMenuDto";
import {MATRIX_APP_ID} from "../constants/Profile";
import {HttpStatus} from "../modules/common/enums/HttpStatus";
import {UserDto} from "../modules/account/dto/UserDto";
import {Outlet, useLocation} from 'react-router-dom';
import {UserApi} from "../modules/account/api/UserApi";
import {useIntl} from "react-intl";
import {ResourceAppApi} from "../modules/account/api/ResourceAppApi";
import {MessageUtils} from "../utils/MessageUtils";
import PasswordDialog from "../pages/account/user/security/components/PasswordDialog";

const AuthorizedLayout: React.FC = () => {
    const intl = useIntl();

    // This hook returns the current location object.
    // This can be useful if you'd like to perform some side effect whenever the current location changes.
    const location = useLocation();

    const [sessionUser, setSessionUser] = useState<UserDto>();

    // 密码修改对话框
    const [openPasswordDialog, setOpenPasswordDialog] = useState(false);

    const [resourceMenus, setResourceMenus] = useState<Array<ResourceMenuDto>>([]);

    useEffect(() => {
        fetchSessionUser();
        fetchAppMenus();
    }, []);

    // 路径变化的时候，重新构造Breadcrumb
    useEffect(() => {
        // getPageName(resourceMenus);
    }, [location]);

    const fetchSessionUser = async () => {
        const responseResult = await UserApi.getSessionUser();
        if (responseResult && responseResult.status === HttpStatus.SUCCESS) {
            const sessionUser = responseResult.data;
            if (!sessionUser.passwordModifyTime) {
                // 如果密码未修改过，则弹框提示修改密码
                MessageUtils.warning(intl.formatMessage({id:'ACCOUNT_USER_PASSWORD_INITIAL_MODIFY_REQUIRED'}));
                setOpenPasswordDialog(true);
            }
            setSessionUser(sessionUser);
        }
    };

    const fetchAppMenus = async () => {
        const responseResult = await ResourceAppApi.getMyResourceMenuTreeList(MATRIX_APP_ID);
        if (responseResult && responseResult.status === HttpStatus.SUCCESS) {
            setResourceMenus(responseResult.data);
        }
    };

    return (
        <div>
            <PasswordDialog open={openPasswordDialog} onClose={() => setOpenPasswordDialog(false)}/>
            <Header sessionUser={sessionUser}/>
            <Grid container spacing={2} style={{padding: '1rem'}}>
                <Grid item xs={2} style={{maxWidth: '15rem', borderRight: '1px solid rgb(229, 234, 239)'}}>
                    <SideMenu resourceMenus={resourceMenus}/>
                </Grid>
                <Grid item xs={10}>
                    {/*<Paper style={{padding: '1rem'}}>*/}
                    <Outlet/>
                    {/*</Paper>*/}
                    <Footer/>
                </Grid>
            </Grid>
        </div>
    );
};

export default AuthorizedLayout;